const TRACKER_TYPES = {
  DAVINCI: 'davinci',
  GOOGLE_ANALYTICS: 'ga_new',
};

export {
  TRACKER_TYPES,
};
